/**
 * Sale End Time Monitor
 * Monitors sale end time and disables ATC buttons when sale ends
 */
(function() {
  'use strict';

  var SALE_ENDED_CLASS = 'is--sale-ended';
  var CHECK_INTERVAL = 1000;

  function initSaleEndMonitor() {
    var buttons = document.querySelectorAll('[data-sale-end-time]');

    if (buttons.length === 0) return;

    buttons.forEach(function(button) {
      var endTimeStr = button.getAttribute('data-sale-end-time');
      var saleEndedText = button.getAttribute('data-sale-ended-text') || '販売終了';
      var saleEndedLink = button.getAttribute('data-sale-ended-link');

      if (!endTimeStr) return;

      var endTime = new Date(endTimeStr).getTime();

      function checkTime() {
        var now = Date.now();

        if (now >= endTime) {
          handleSaleEnded(button, saleEndedText, saleEndedLink);
          return true;
        }
        return false;
      }

      if (!checkTime()) {
        var intervalId = setInterval(function() {
          if (checkTime()) {
            clearInterval(intervalId);
          }
        }, CHECK_INTERVAL);
      }
    });
  }

  function handleSaleEnded(button, text, link) {
    if (link) {
      replaceWithLink(button, text, link);
    } else {
      disableButton(button, text);
    }

    hideDynamicCheckout();
    disableStickyButton(text, link);
  }

  function disableButton(button, text) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add(SALE_ENDED_CLASS);
    button.removeAttribute('data-action-atc');
    button.removeAttribute('data-atc-form');
    button.type = 'button';

    var textSpan = button.querySelector('.t4s-btn-atc_text, .t4s-text-pr');
    if (textSpan) {
      textSpan.textContent = text;
    }
  }

  function replaceWithLink(button, text, link) {
    var newElement = document.createElement('a');
    newElement.href = link;
    newElement.className = button.className;
    newElement.classList.remove('t4s-btn-loading__svg');
    newElement.classList.add(SALE_ENDED_CLASS);

    var icon = button.querySelector('.t4s-btn-icon, .t4s-svg-pr-icon');
    if (icon) {
      newElement.appendChild(icon.cloneNode(true));
    }

    var textSpan = document.createElement('span');
    textSpan.className = 't4s-btn-atc_text';
    textSpan.textContent = text;
    newElement.appendChild(textSpan);

    button.parentNode.replaceChild(newElement, button);
  }

  function disableStickyButton(text, link) {
    var stickyBtn = document.querySelector('[data-sticky-addtocart] [data-action-atc], .t4s-sticky-atc__atc');
    if (stickyBtn && !stickyBtn.classList.contains(SALE_ENDED_CLASS)) {
      if (link) {
        replaceWithLink(stickyBtn, text, link);
      } else {
        disableButton(stickyBtn, text);
      }
    }
  }

  function hideDynamicCheckout() {
    var paymentButton = document.querySelector('.shopify-payment-button');
    if (paymentButton) {
      paymentButton.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaleEndMonitor);
  } else {
    initSaleEndMonitor();
  }

  document.addEventListener('shopify:section:load', initSaleEndMonitor);
})();
